<div class="flex flex-column">

  <div class="content-container mb-2">
    <p [innerHTML]="config.data?.data?.confirmationMessage | safe:'html'"></p>
  </div>

  <div class="formgrid grid mb-3">
    <div class="field col-12">
      <label for="reason" class="block mb-2">Reason for closing (optional)</label>
      <textarea 
        id="reason" 
        [(ngModel)]="reason" 
        rows="5" 
        cols="30" 
        pInputTextarea 
        class="w-full">
      </textarea>
    </div>
  </div>

  <div class="actions-container flex-1 flex justify-content-end">
    <button 
      pButton 
      pRipple 
      type="button" 
      label="Cancel" 
      class="p-button-secondary" 
      (click)="onCancel()">
    </button>
    <button 
      pButton 
      pRipple 
      type="button" 
      label="Confirm" 
      class="" 
      (click)="onConfirm()">
    </button>
  </div>

</div>

